import React from 'react';
import { Button, Stack, TextField, Typography } from '@mui/material';
import { AppDialog } from './AppDialog';

type LiveShareDialogProps = {
  open: boolean;
  onClose: () => void;
  link: string;
  onCopy: () => void;
  onStop: () => void;
  active: boolean;
};

export function LiveShareDialog({ open, onClose, link, onCopy, onStop, active }: LiveShareDialogProps) {
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title="Live Share"
      maxWidth="sm"
      fullWidth
      actions={(
        <>
          <Button onClick={onClose}>Schließen</Button>
          <Button
            variant="outlined"
            onClick={onCopy}
          >
            Link kopieren
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={onStop}
            disabled={!active}
          >
            Live Share beenden
          </Button>
        </>
      )}
    >
      <Stack spacing={2} sx={{ mt: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Teile diesen Link mit Kollegen. Sobald sie ihn öffnen, synchronisiert sich der Chat live.
        </Typography>
        <TextField
          label="Live Share Link"
          value={link}
          fullWidth
          InputProps={{ readOnly: true }}
        />
      </Stack>
    </AppDialog>
  );
}
